/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import typography from '../../typography';
import colors from '../../colors';

// Soft UI Dashboard PRO React helper functions
// import pxToRem from "../../functions/pxToRem";

const { size } = typography;
const { body } = colors;

export default {
    styleOverrides: {
        root: {
            fontSize: size.md,
            color: body.main,
        },
    },
};
